import { render, staticRenderFns } from "./RequiredManagement.vue?vue&type=template&id=761a1d9d&scoped=true&"
import script from "./RequiredManagement.vue?vue&type=script&lang=js&"
export * from "./RequiredManagement.vue?vue&type=script&lang=js&"
import style0 from "./RequiredManagement.vue?vue&type=style&index=0&id=761a1d9d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761a1d9d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
